import { render, staticRenderFns } from "./Coin3D.vue?vue&type=template&id=76b0a99e&scoped=true"
import script from "./Coin3D.vue?vue&type=script&lang=js"
export * from "./Coin3D.vue?vue&type=script&lang=js"
import style0 from "./Coin3D.vue?vue&type=style&index=0&id=76b0a99e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b0a99e",
  null
  
)

export default component.exports